function initializeVelinaShopping(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const storageKey = 'velina-wishlist';
  let saved = new Set();
  try {
    const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(stored)) saved = new Set(stored);
  } catch {}
  const cards = [...root.querySelectorAll('[data-product]')];
  const colour = root.querySelector('[data-colour]');
  const wishlist = root.querySelector('[data-saved-only]');
  const more = root.querySelector('[data-more]');
  const dialog = root.querySelector('dialog');
  const dialogBody = root.querySelector('[data-quick-body]');
  let limit = 8;

  function render() {
    const savedOnly = wishlist.getAttribute('aria-pressed') === 'true';
    let matches = 0;
    let savedCount = 0;
    for (const card of cards) {
      const isSaved = saved.has(card.dataset.product);
      const heart = card.querySelector('[data-save]');
      heart.setAttribute('aria-pressed', String(isSaved));
      heart.firstElementChild.textContent = isSaved ? '♥' : '♡';
      if (isSaved) savedCount += 1;
      const matchesFilter = savedOnly ? isSaved :
        colour.value === 'all' || card.dataset.productColour === colour.value;
      if (matchesFilter) matches += 1;
      card.hidden = !matchesFilter || matches > limit;
    }
    more.hidden = matches <= limit;
    root.querySelector('[data-empty]').hidden = matches !== 0;
    root.querySelector('[data-saved-count]').textContent = savedCount;
  }

  root.querySelector('[data-colour-controls]').hidden = false;
  wishlist.hidden = false;
  for (const card of cards) {
    card.querySelector('[data-save]').hidden = false;
    card.querySelector('[data-quick]').hidden = false;
  }
  colour.addEventListener('change', () => {
    wishlist.setAttribute('aria-pressed', 'false');
    limit = 8;
    render();
  });
  wishlist.addEventListener('click', () => {
    wishlist.setAttribute('aria-pressed', String(wishlist.getAttribute('aria-pressed') !== 'true'));
    colour.value = 'all';
    limit = 8;
    render();
  });
  more.addEventListener('click', () => {
    const firstHidden = cards.find(card => card.hidden &&
      (wishlist.getAttribute('aria-pressed') === 'true' ? saved.has(card.dataset.product) :
        colour.value === 'all' || card.dataset.productColour === colour.value));
    limit += 8;
    render();
    firstHidden?.querySelector('a')?.focus();
  });
  root.addEventListener('click', event => {
    const control = event.target.closest('[data-save], [data-quick]');
    if (!control) return;
    const card = control.closest('[data-product]');
    if (control.hasAttribute('data-quick')) {
      dialogBody.replaceChildren(card.querySelector('template').content.cloneNode(true));
      dialogBody.querySelector('[data-dialog-title]').id = dialog.getAttribute('aria-labelledby');
      dialog.showModal();
      return;
    }
    const id = card.dataset.product;
    if (saved.has(id)) saved.delete(id);
    else saved.add(id);
    try { localStorage.setItem(storageKey, JSON.stringify([...saved])); } catch {}
    render();
  });
  render();
}

document.querySelectorAll('[data-velina-shopping]').forEach(initializeVelinaShopping);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('[data-velina-shopping]').forEach(initializeVelinaShopping);
});